import InvitationViewPage from "@/views/invitation/InvitationViewPage.vue";
import KioskViewPage from "@/views/kiosk/KioskViewPage.vue";

const invitationRoutes = [
    {
        path: "/invitation",
        children: [
          {
            path: ":orderNum",
            name: "InvitationViewPage",
            components: {
              default: InvitationViewPage,
            },
            props: {
              default: true,
            },
          },
          {
            path: "kiosk/:orderNum",
            name: "KioskViewPage",
            components: {
              default: KioskViewPage,
            },
            props: {
              default: true,
            }
          }
        ],
      },
]

export default invitationRoutes;